module.exports = __webpack_public_path__ + "img/fiat-2012-calendar-teaser-01.7a574adb.jpg";